/* eslint no-undef: 0 */

const createHistory = require('history').createBrowserHistory

export const history = createHistory()

export const createSpaceRoute = () => '/space'
export const spaceRoute = (spaceId:number) => `/spaces/${spaceId}`
export const spacesRoute = () => '/spaces'

export const tracingsRoute = () => '/tracing'
// TODO: leaving this editCaseRoute as is with an unused arg, but
// probably needs to be changed
export const editCaseRoute = (_caseId:any) => '/case'
export const caseRoute = (caseId:number) => `/case/${caseId}`

export const isViewTypes = (loc: typeof window.location, type:string) => {
  const href = loc && loc.href ? loc.href : window.location.href
  const origin = loc && loc.origin ? loc.origin : window.location.origin
  const pathName = href.substr(origin.length)
  const newType = new RegExp(`${type}`, 'g')
  return newType.test(pathName)
}
